export function SkeletonChart() {
  return (
    <div className="container" style={{ marginTop: '2rem' }}>
      <div className="row g-4">
        {[...Array(2)].map((_, i) => (
          <div key={i} className="col-12 col-md-6">
            <div
              className="skeleton-shimmer mb-3 rounded"
              style={{ width: '100%', height: '45px' }}
            ></div>

            <div
              className="skeleton-shimmer rounded"
              style={{ width: '100%', height: '250px', marginTop: '1rem' }}
            />
            <div
              className="skeleton-shimmer rounded"
              style={{ width: '100%', height: '250px', marginTop: '1rem' }}
            />
            <div
              className="skeleton-shimmer rounded"
              style={{ width: '100%', height: '250px', marginTop: '1rem' }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
